import React, {useEffect, useState} from 'react';
import {useHistory, useRouteMatch} from "react-router-dom";
import {Box, Grid} from "@material-ui/core";
import {useSnackbar} from "notistack";
import {makeColoredSwitch} from "components/helpers/colored.switch";
import {ReactGrid} from 'components/helpers/reactGrid/reactGrid';
import SubHeader from "components/helpers/subHeader/subHeader";
import {useVendedoresService} from "services/hooks";

// Las filas de los inhabilitados se pintan del mismo color que el switch que las muestra.
export const COLOR_INHABILITADO = 'rgb(255,84,84, 0.5)';
const InhabilitadoSwitch = makeColoredSwitch(COLOR_INHABILITADO);

const rowExtensions = {
    color: vendedor => vendedor.inhabilitado ? COLOR_INHABILITADO : ''
};

export const VendedoresList = () => {
    const VendedoresService = useVendedoresService();
    const {enqueueSnackbar} = useSnackbar();
    const history = useHistory();
    const match = useRouteMatch();

    // Van en el estado y no como constantes del módulo: ReactGrid les hace push de la columna de
    // edición, y con un array compartido se sumaba una columna más cada vez que se entraba a la pantalla.
    const [columns] = useState(() => [
        {name: 'id', title: 'ID'},
        {name: 'apenom', title: 'Nombre'},
        {name: 'categoria', title: 'Categoría'},
        {name: 'supervisor', title: 'Supervisor'}
    ]);
    const [columnExtensions] = useState(() => [
        {columnName: 'id', width: 130},
        {columnName: 'categoria', width: 130},
    ]);

    const [vendedores, setVendedores] = useState([]);
    const [inhabilitados, setInhabilitados] = useState(true);

    useEffect(() => {
        VendedoresService.getFichas(
            response => setVendedores(response.data.result),
            error => enqueueSnackbar(error, {variant: 'error'})
        );
    }, []);

    const rows = vendedores.filter(vendedor => !vendedor.inhabilitado || inhabilitados);

    const navEdit = row => history.push(`${match.url}/edit/${row.id}`);

    return (
        <Box className='niquel-vendedores-list'>
            <SubHeader
                title={'Vendedores'}
                subtitle={'Listado de vendedores'}
            />
            <Box className='container-xl mt-3 mb-3'>
                <Grid container spacing={2}>
                    <Grid item>
                        Inhabilitados
                        <InhabilitadoSwitch
                            checked={inhabilitados}
                            onChange={() => setInhabilitados(!inhabilitados)}
                        />
                    </Grid>
                </Grid>
                <Box className='mt-3'>
                    <ReactGrid
                        title={'Vendedores'}
                        showResultCount
                        height={-240}
                        columns={columns}
                        columnExtensions={columnExtensions}
                        rowExtensions={rowExtensions}
                        rows={rows}
                        enableFiltering={false}
                        rowClick={false}
                        enableEdition
                        onEdit={navEdit}
                    />
                </Box>
            </Box>
        </Box>
    );
};
